<template>
  <div class="system-box">
    <div >
      <el-form :model="form" ref="form" label-width="120px" :rules="rules" >
        <el-form-item label="地区：" v-show="!loginData.organization">
          <el-select v-model="placeData[0]" clearable @change="remoteMethod($event,1)" placeholder="省">
            <el-option v-for="x in province" :key="x.id" :label="x.name" :value="x.id"></el-option>
          </el-select>
          <el-select v-model="placeData[1]" clearable @change="remoteMethod($event,2)" placeholder="市">
            <el-option v-for="x in city" :key="x.id" :label="x.name" :value="x.id"></el-option>
          </el-select><br />
          <el-select v-model="placeData[2]" clearable @change="remoteMethod($event,3)" placeholder="县">
            <el-option v-for="x in county" :key="x.id" :label="x.name" :value="x.id"></el-option>
          </el-select>
          <el-select v-model="placeData[3]" clearable @change="remoteMethod($event,4)" placeholder="镇" style="margin-top:10px">
            <el-option v-for="x in town" :key="x.id" :label="x.name" :value="x.id"></el-option>
          </el-select><br />
          <el-select v-model="placeData[4]" clearable @change="remoteMethod($event,5)" placeholder="村" style="margin-top:10px">
            <el-option v-for="x in village" :key="x.id" :label="x.name" :value="x.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="旧密码：" prop="pass">
          <el-input type="password" v-model="form.pass"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="newPass">
          <el-input type="password" v-model="form.newPass"></el-input>
        </el-form-item>
        <el-form-item label="请确认新密码：" prop="checkPass">
          <el-input type="password" v-model="form.checkPass"></el-input>
        </el-form-item>
        <el-form-item label="">            
          <el-button type="primary" @click="submit()">确定修改</el-button>
          <!-- <el-button type="primary" v-show="login" @click="$router.push('login')">重新登陆</el-button> -->
          <el-button type="primary" @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        pass: '',
        newPass: '',
        checkPass: '',
      },
      login: false,
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      placeData: [],
      rules: {
        newPass: [{ validator: validatePass, trigger: 'blur' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
      loginData: {}
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let place = []
          if (this.loginData.personal) {
            //过滤空字符串
            console.log(this.placeData)
            place = this.placeData.filter(x => !!x)
            if (place.length === 0) {
              this.$message.info('请先选择地区')
            } else {
              this.$api.userInfoChange(this.loginData.id,place[place.length-1]).then(res =>{
                if (res.data.status === 0) {
                  this.$message.success('地区设置成功！请重新登录系统')
                } else {
                  this.login = false
                  this._status(res.data)
                }
              }) 
            }  
          } 
          if (this.loginData.personal && place.length == 0) {
            return false
          } else {
            
            let rD = {
              id: this.userInfo.id,
              password: this.form.newPass,
            }
            this.$api._user_modify(rD).then(res => {
              if (res.data.status === 0) {
                this.login = true
                this.$message.success('密码修改成功！请重新登录系统')

                let timer = setTimeout(() => {
                  if (this.login) {
                    this.$router.push('login')
                    window.clearTimeout(timer)
                  }
                }, 3000)
              } else {
                this.login = false
                this._status(res.data)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.placeData = []
    },
    // 获取位置
    areaGet(data) {
      let vm = this
      vm.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : vm.province = response;break
            case 1 : vm.city = response;break
            case 2 : vm.county = response;break
            case 3 : vm.town = response;break
            case 4 : vm.village = response;break
            case 5 : vm.village = response;break
            default : break
          }
        } else{
          this._status(res.data)
        }
      })
    },
    //清空下级
    remoteMethod(value,num) {
      switch(num) {
        case 1 : this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break
        case 2 : this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break
        case 3 : this.placeData[3] = this.placeData[4] = ''; break
        case 4 : this.placeData[4] = ''; break
        default : break;
      }
      this.areaGet({value: {areaId:value},key:num})
    },
  },
  created() {
    this.loginData = JSON.parse(window.localStorage.getItem('loginData'))
    this.loginData.isOrganization ? '' : this.areaGet({value: {areaId:0},key:0})
  },
}
</script>

<style scoped>
.system-box{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
</style>